import {FC, useEffect, useState} from "react";
import {Layout} from "../../../containers";
import {
    Button,
    Card,
    Icon,
    Input,
    Loading,
    Modal,
    Select,
    Table, Text,
    Title,
    useModal
} from "../../../components/UI";
import {alertService} from "../../../services/alert.services";
import {useForm} from "react-hook-form";

interface IAlertSaveForm {
    name: string
    text: string
    color_id: string
}
const pageDefault: number = 1

const AdminAlertsPage:FC=()=>{

    const { register, handleSubmit, getValues, reset } = useForm<IAlertSaveForm>()
    const [alerts, setAlerts] = useState<any>({})
    const [alertColors, setAlertColors] = useState<any>({})
    const [submited, setSubmited] = useState<boolean>(false)
    const [btnCrear, setBtnCrear] = useState<boolean>(true)
    const [btnModal, setBtnModal] = useState<boolean>(false)
    const [btnSave, setBtnSave] = useState<boolean>(false)
    const [visibleForm, setvisibleForm] = useState<string>('none')
    const [loadForm, setLoadForm] = useState<boolean>(false)
    const [idUpdate, setIdUpdate] = useState<any>()
    const [alertDel, setAlertDel] = useState<any>({})
    const [statusList, setStatusList] = useState<any>([])
    const [pageCurrent, setPageCurrent] = useState<number>(pageDefault)


    const modalDelete = useModal()

    useEffect(() => {
        setAlertData()
    }, [])

    const setAlertData = async (filter: string = '', status: number = 0, page: number = 1) => {
        setSubmited(true)
        register('name',{value:''})
        register('text',{value:''})
        register('color_id',{value:''})
        setIdUpdate(null)
        const alertColor = await alertService.getAlertColors()
        setAlertColors(alertColor.data)
        const alertData = await alertService.getAlerts(filter, status, page)
        setAlerts(alertData.data)
        setSubmited(false)
        setBtnCrear(false)
    }
    const reloadAlertData = async (filter: string = '', status: number = 0, page: number = 1) => {
        setSubmited(true)
        register('name',{value:''})
        register('text',{value:''})
        register('color_id',{value:''})
        setIdUpdate(null)
        const alertData = await alertService.getAlerts(filter, status, page)
        setAlerts(alertData.data)
        setSubmited(false)
        setBtnCrear(false)
    }

    /* mostrar / ocultar form  */
    const showFrom = async () => {
        setLoadForm(true)
        setvisibleForm('')
        setLoadForm(false)
        setBtnCrear(true)
    }
    const hiddenFrom = () => {
        setLoadForm(true)
        setvisibleForm('none')
        reset()
        setIdUpdate(null)
        setLoadForm(false)
        setBtnCrear(false)
        setBtnSave(false)
    }
    /* fin mostrar / ocultar form  */

    /* guardar y actualizar  */
    const onSaveSubmit = async (data: IAlertSaveForm) => {
        const name  = data.name
        const text  = data.text
        const color_id  = Number(data.color_id)
        if (name && text && color_id){
            setBtnSave(true)
            if (idUpdate){
                await alertService.updateAlert(data, idUpdate)
            }else {
                await alertService.registerAlert(data)
            }
            hiddenFrom()
            reloadAlertData()
            setvisibleForm('none')
        }
    }
    const onUpdateSubmit = async (data : any) =>{
        setBtnSave(true)
        const alertData = await alertService.getAlertById(Number(data))
        const alertUpdate = alertData.data.data
        register('name',{value:alertUpdate.name})
        register('text',{value:alertUpdate.text})
        register('color_id',{value:alertUpdate.color_id})
        setIdUpdate(alertUpdate.id)
        showFrom()
        setBtnSave(false)
    }
    /* fin guardar y actualizar  */



    /* cambiar estado */
    const filterStatus = (id : any) =>{
        return (
            statusList.filter((e : any) => e.id === id).map((data : any) => (
                {data}
            ))
        )
    }
    const onStatusCheck = (id: any, status: boolean ) => {
        setBtnSave(true)
        var list = statusList
        if (list.length){
            let statusItem = filterStatus(id)[0]
            if (statusItem){
                {list.map((it: any, i: number) => {
                    if (list[i].id == id){
                        list[i].status = !list[i].status
                    }
                })}
            }else{
                var array = {
                    'id' : id,
                    'status' : ! status
                }
                list.push(array)
            }
        }else {
            var array = {
                'id' : id,
                'status' : ! status
            }
            list.push(array)
        }
        setStatusList(list)
        setBtnSave(false)
        return true
    }
    const onSaveStatusSubmit = async (id : any) => {
        setBtnSave(true)
        var list = statusList
        if (list.length){
            let statusItem = filterStatus(id)[0].data
            if (statusItem){
                await alertService.updateAlertStatus(Number(id),statusItem.status)
                setStatusList([])
                reloadAlertData()
            }
        }
        setBtnSave(false)
    }
    /* fin cambiar estado */

    /* Eliminar alerta */
    const onModalShow = (data: any) => {
        setAlertDel(data)
        modalDelete.open()
    }
    const onDeleteSubmit = async () => {
        setBtnModal(true)
        const id = alertDel.id
        await alertService.deleteAlert(id)
        setIdUpdate(null)
        modalDelete.close()
        reloadAlertData()
        setBtnModal(false)
    }
    /* fin Eliminar alerta */

    /* cargar tabla */
    const tableColumns = [

        {
            accessor: 'name',
            Header: 'Nombre alerta',
            width: '16%',
            Cell:   (params: any) => {
                const {original} = params.row
                const id = original.id
                const name = original.name
                return (
                    <span>
                        <input type="hidden" name={'id'} id={'id'} value={id}/>
                        {name}
                    </span>
                )
            }
        },
        {
            accessor: 'text',
            Header: 'Texto alerta',
            width: '30%'
        },
        {
            accessor: 'color_id',
            Header: 'Color',
            width: '10%',
            Cell:   (params: any) => {
                const {original} = params.row
                const id = original.color_id
                const data = alertColors.data
                var data_color = []
                for (var i = 0; i < data.length; i++) {
                    if (data[i].id === id){
                        data_color = data[i]
                    }
                }
                return (
                    <span
                        style={
                        {
                            color: data_color.primary_code,
                            width:'118px',
                            display: 'block',
                            margin : '0 auto',
                            textShadow : '0px 1px 3px rgba(85, 78, 78, 1)'
                        }}>
                        {data_color.color}</span>
                )
            }
        },
        {
            accessor: 'status_id',
            Header: 'Estado',
            width: '10%',
            Cell: (params: any) => {
                const {original} = params.row
                const status = original.status_id
                const id = original.id
                return (
                    <input
                        type='checkbox'
                        defaultChecked={status === 1}
                        className={`switch`}
                        id={"status_"+id}
                        name={"status_id"}
                        onClick={()=>(onStatusCheck(id,status === 1))}
                    />
                )


            }
        },
        {
            accessor: 'action',
            Header: 'Acción',
            width: '10%',
            Cell: (params: any) => {
                const {original} = params.row
                const id = original.id

                return (
                    <div className="d-flex">
                        <Button
                            component="button"
                            mode="circle"
                            size="sm"
                            onClick={() => onUpdateSubmit(id)}
                            disabled={btnSave}
                        >
                            <Icon name="edit"/>
                        </Button>
                        <Button
                            component="button"
                            mode="circle"
                            size="sm"
                            className="ml-5"
                            onClick={() => onModalShow(original)}
                            disabled={btnSave}
                        >
                            <Icon name="disabled"/>
                        </Button>
                        <Button component="button"
                                mode="circle"
                                size="sm"
                                className="ml-5"
                                onClick={() => onSaveStatusSubmit(id)}
                                disabled={btnSave}
                        >
                            <Icon name="save"/>
                        </Button>
                    </div>
                )
            }
        }
    ]
    /* fin cargar tabla */


    return (
        <Layout role="ADMIN_ROLE" menu={true}>
            <Title border>Administrador de alertas</Title>

            <Card className="mt-50 py-20 px-70">
                <div style={{ flex:'0 0 170px', maxWidth: '170px' }}>
                    <Button
                        component="button"
                        size="md"
                        onClick={showFrom}
                        disabled={btnCrear}
                    >CREAR ALERTA</Button>
                </div>
                <form autoComplete="off" style={{display:visibleForm}} className={'mt-30'} onSubmit={handleSubmit(onSaveSubmit)}>
                    <div className="d-flex">
                        <div className="col pl-0 d-flex" style={{ width: '100%' }}>
                            <div style={{width: '145px'}} >
                                <Input
                                    {...register('name')}
                                    placeholder="Ingrese nombre"
                                    size={32}
                                    name={"name"}
                                    id={"name"}
                                    version="2"
                                    fullWidth={true}
                                    required={true}
                                    defaultValue={getValues('name')}
                                />
                            </div>
                            <div style={{width: '360px'}} className={'ml-10'}>
                                <Input
                                    {...register('text')}
                                    placeholder="Ingrese texto"
                                    name={"text"}
                                    id={"text"}
                                    version="2"
                                    fullWidth={true}
                                    required={true}
                                    defaultValue={getValues('text')}
                                />
                            </div>
                            <div style={{width: '145px'}} className={'ml-10'}>
                                <Select
                                    {...register('color_id')}
                                    name={"color_id"}
                                    version="3"
                                    fullWidth
                                    required={true}
                                >
                                    <option key={0} value={0}>{'Seleccione color'}</option>
                                    { alertColors.data && alertColors.data.length > 0 && alertColors.data.map((it: any, i: number) => {

                                        if (getValues('color_id')){
                                            if (it.id === getValues('color_id')){
                                                return (
                                                    <option selected={true} key={i} value={it.id}>{`${it.color}`}</option>
                                                )
                                            }
                                        }
                                        return (
                                            <option key={i} value={it.id}>{`${it.color}`}</option>
                                        )
                                    })}
                                </Select>
                            </div>
                            <div style={{width: '170px'}} className={'ml-10'}>
                                <Button
                                    type="submit"
                                    size="md"
                                    fullWidth={true}
                                    disabled={btnSave}
                                >GUARDAR</Button>
                            </div>
                            <div style={{width: '50px'}} className={'ml-10'}>

                                <Button component="button" size="md" className="btn--close" onClick={hiddenFrom}>
                                    <Icon
                                    name={'icon-cross'}
                                    color="gray"
                                    />
                                </Button>
                            </div>
                        </div>
                    </div>
                    {loadForm && <Loading overlay />}
                </form>
                <div className="position-relative mt-30" style={{ minHeight: 150 }}>
                    <Table
                        columns={tableColumns}
                        data={alerts.alert ? alerts.alert  : []}
                    />
                    {submited && <Loading overlay />}
                </div>
            </Card>

            <Modal show={modalDelete.show} maxWidth="345px" onClose={() => modalDelete.close()}>
                <div className="text-center pt-70 pb-60 px-50">
                    <Text component="label" size="20" weight="bold">¿Estas seguro(a) que deseas eliminar esta alerta?</Text>

                    <div className="mt-40">
                        <Button fullWidth onClick={onDeleteSubmit} disabled={btnModal}>SÍ, ELIMINAR</Button>
                        <Button fullWidth className="mt-10" onClick={() =>  modalDelete.close()}>NO, CANCELAR</Button>
                    </div>
                </div>
            </Modal>
        </Layout>

    )
}
export {AdminAlertsPage}
